import api from "./client";

export async function listMaterials(params = {}) {
  const data = await listMaterialsPaged(params);
  return data.items;
}

export async function listMaterialsPaged(params = {}) {
  const res = await api.get("/materials", { params });
  return res.data.data;
}

export async function createMaterial(payload) {
  const res = await api.post("/materials", payload);
  return res.data.data;
}

export async function updateMaterial(id, payload) {
  const res = await api.put(`/materials/${id}`, payload);
  return res.data.data;
}

export async function deleteMaterial(id) {
  const res = await api.delete(`/materials/${id}`);
  return res.data.data;
}

// Material -> Variant Template
export async function getMaterialVariantDimensions(materialId) {
  const res = await api.get(`/materials/${materialId}/variant-dimensions`);
  return res.data.data.items;
}

export async function replaceMaterialVariantDimensions(materialId, items) {
  const res = await api.put(`/materials/${materialId}/variant-dimensions`, { items });
  return res.data.data;
}

// Material -> BOM
export async function getMaterialBom(materialId, { variantId = null, manufacturingSource = 1 } = {}) {
  const params = new URLSearchParams();
  if (variantId) params.set("variant_id", String(variantId));
  if (manufacturingSource != null) params.set("manufacturing_source", String(manufacturingSource));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/materials/${materialId}/bom${qs}`);
  return res.data.data; // { bom, items }
}

export async function replaceMaterialBom(materialId, payload, { variantId = null, manufacturingSource = 1 } = {}) {
  const params = new URLSearchParams();
  if (variantId) params.set("variant_id", String(variantId));
  if (manufacturingSource != null) params.set("manufacturing_source", String(manufacturingSource));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.put(`/materials/${materialId}/bom${qs}`, payload);
  return res.data.data; // { bom_id, version }
}

export async function explodeMaterialBom(materialId, { qty, variantId = null, policy = "all", manufacturingSource = 1 } = {}) {
  const params = new URLSearchParams();
  params.set("qty", String(qty));
  if (variantId) params.set("variant_id", String(variantId));
  if (policy) params.set("policy", String(policy));
  if (manufacturingSource != null) params.set("manufacturing_source", String(manufacturingSource));
  const res = await api.get(`/materials/${materialId}/bom/explode?${params.toString()}`);
  return res.data.data;
}

// Resolve (or create) a material variant from dimension selections
export async function resolveVariant(materialId, selections) {
  const res = await api.post(`/materials/${materialId}/resolve-variant`, { selections });
  return res.data.data; // { material_variant_id, display_name }
}

// Material -> Routing
export async function getMaterialRouting(materialId, { variantId = null, manufacturingSource = 1 } = {}) {
  const params = new URLSearchParams();
  if (variantId) params.set("variant_id", String(variantId));
  if (manufacturingSource != null) params.set("manufacturing_source", String(manufacturingSource));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/materials/${materialId}/routing${qs}`);
  return res.data.data; // { routing, operations }
}

// Excel import
export async function validateMaterialsImport(rows) {
  const res = await api.post("/materials/import/validate", { rows });
  return res.data.data; // { resolved, errors }
}

export async function importMaterials(rows) {
  const res = await api.post("/materials/import", { rows });
  return res.data.data; // { materials_created, materials_updated, variants_inserted, variants_updated, ids, errors }
}

export async function validateBomRoutingImport(rows) {
  const res = await api.post("/materials/bom-routing/import/validate", { rows });
  return res.data.data;
}

export async function importBomRouting(rows, manufacturingSource = 1) {
  const res = await api.post("/materials/bom-routing/import", { rows, manufacturing_source: manufacturingSource });
  return res.data.data;
}

export async function replaceMaterialRouting(materialId, payload, { variantId = null, manufacturingSource = 1 } = {}) {
  const params = new URLSearchParams();
  if (variantId) params.set("variant_id", String(variantId));
  if (manufacturingSource != null) params.set("manufacturing_source", String(manufacturingSource));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.put(`/materials/${materialId}/routing${qs}`, payload);
  return res.data.data; // { routing_id, version }
}

